import React, { Fragment, ReactNode } from 'react';
import styles from './index.module.css';
import { ReactComponent as TickIcon } from 'assets/icons/tick-circle.svg';
import { formatTime, getDurationSince } from 'utils/functions';

type Props = {
  start?: boolean;
  end?: boolean;
  text: string;
  innerText?: string;
  time?: string | null;
  timeSince?: string | null;
  children?: ReactNode;
  hideMark?: boolean;
  isCancelled?: boolean;
};

const TrackOrderState = ({
  start,
  end,
  text,
  time,
  innerText,
  children,
  hideMark,
  timeSince = new Date().toISOString(),
  isCancelled
}: Props) => {
  let active = true;

  console.log({ time, isCancelled });
  if (!time && !isCancelled) active = false;
  const timeObj = time === undefined || time === null ? undefined : new Date(time);

  return (
    <Fragment>
      <div className='flex w-full'>
        <div className={styles['track-mark'] + (active ? ` ${styles['active']}` : '')}>
          <div className={start ? 'invisible' : ''}></div>
          {hideMark ? <svg style={{ height: 0 }}></svg> : <TickIcon />}
          <div className={end ? 'invisible' : ''}></div>
        </div>
        <div className='pl-2 py-4 md:py-0 flex flex-col gap-1 md:flex-row grow'>
          <div className='flex-auto md:self-center text-sm md:text-base grow'>
            <div className={active ? '' : 'text-gray-8'}>{text}</div>
            <div className='text-sm text-gray-5'>{innerText}</div>
          </div>
          <div className='md:self-center'>
            {active ? (
              <div className='text-right'>
                <div className='text-sm text-gray-5'>{time ? formatTime(time) : '--'}</div>
                <div className='text-sm text-gray-5'>
                  {timeObj && timeSince && getDurationSince(timeObj, new Date(timeSince))}
                </div>
              </div>
            ) : (
              <div
                className={`${styles['faint-background-button']} text-sm text-gray-5 inline-block`}>
                Pending
              </div>
            )}
          </div>
        </div>
      </div>
      {children}
    </Fragment>
  );
};

export default TrackOrderState;
